function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#FFF",
  cx: 64,
  cy: 64,
  r: 64
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.264 76.823c-2.519 0-5.264 1.381-5.264 4.012v1.093c0 2.72 2.829 3.954 5.264 3.954 2.55 0 5.324-1.219 5.324-3.954v-1.093c0-2.359-2.306-4.012-5.324-4.012m0-36.823c-2.519 0-5.264 1.585-5.264 4.612V67.64c0 3.124 2.829 4.55 5.264 4.55 2.55 0 5.324-1.406 5.324-4.55V44.612c0-2.715-2.306-4.612-5.324-4.612",
  fill: "#FFE200"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.376 40.901H47.4c-2.396-.001-3.36 1.477-4.07 3.203l-8.018 17.94-8.022-17.94c-.776-1.726-1.68-3.204-4.07-3.204h-.967c-2.012 0-3.754 1.732-3.754 3.718v37.614c0 2.5 1.876 3.65 3.754 3.65 1.867 0 3.746-1.15 3.746-3.65V58.778l5.493 12.563c.971 2.112 2.592 2.494 3.82 2.494 1.229 0 2.845-.382 3.81-2.494l5.5-12.563v23.454c0 2.497 1.874 3.65 3.753 3.65 1.874 0 3.746-1.153 3.746-3.65V44.618c0-1.986-1.75-3.717-3.746-3.717zm41.499 0h-.974c-2.397-.001-3.361 1.477-4.07 3.203l-8.018 17.94-8.022-17.94c-.776-1.726-1.68-3.204-4.07-3.204h-.968C61.742 40.9 60 42.632 60 44.618v37.614c0 2.5 1.876 3.65 3.753 3.65 1.868 0 3.747-1.15 3.747-3.65V58.778l5.492 12.563c.972 2.112 2.593 2.494 3.821 2.494 1.228 0 2.845-.382 3.81-2.494l5.499-12.563v23.454c0 2.497 1.874 3.65 3.753 3.65 1.875 0 3.747-1.153 3.747-3.65V44.618c0-1.986-1.75-3.717-3.747-3.717z",
  fill: "#474B50"
}));

function SvgMmWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmWhite);
export default __webpack_public_path__ + "static/media/mm_white.45cd9be6.svg";
export { ForwardRef as ReactComponent };